import { useContext } from 'react';

import {
    createAutocompleteActionContext,
    createAutocompleteProvider,
    createAutocompleteStateContext,
} from 'component/Layout/Autocomplete';

import { Iata } from 'types/Search/airport';

import { AirportAcItemList } from '../types';

const AirportAutocompleterContext =
    createAutocompleteStateContext<AirportAcItemList, Iata>();
AirportAutocompleterContext.displayName = 'AirportAutocompleterContext';
const AirportAutocompleterActionContext =
    createAutocompleteActionContext<AirportAcItemList, Iata>();
AirportAutocompleterActionContext.displayName =
    'AirportAutocompleterActionContext';

const AirportProvider = createAutocompleteProvider(
    AirportAutocompleterContext,
    AirportAutocompleterActionContext
);

export const useAirportAutocompleterState = () => {
    return useContext(AirportAutocompleterContext);
};

export const useAirportAutocompleterAction = () => {
    return useContext(AirportAutocompleterActionContext);
};

export default AirportProvider;
